import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { pdfStyles } from '../../../../../components';
import {
  DEFAULT_SUBTOTAL_SIGN,
  getNewSubtotalUtility,
  getTotalChargesReturns,
} from '../../../../../config/utils/reportUtils';
import { CURRENCY } from '../../../../../interfaces/enumerables';
import { CustomerReportDoc } from '../../../../../interfaces/reports.interface';

interface Props {
  data: CustomerReportDoc[];
}

export const CustomerTableTotalsPdf = ({ data }: Props) => {
  const { t } = useTranslation();

  const finalSubtotals = useMemo(() => {
    const len = data?.length;
    if (len > -1) {
      return getNewSubtotalUtility(data?.[len - 1]);
    }

    return { rawValue: '0.00', currentPosSubtotal: '', currentNegSubtotal: '' };
  }, [data]);

  const getPosSubtotal = useCallback(() => {
    if (finalSubtotals?.currentPosSubtotal === DEFAULT_SUBTOTAL_SIGN) {
      return finalSubtotals?.currentPosSubtotal;
    }
    return `${finalSubtotals?.currentPosSubtotal || '0.00'} ${CURRENCY.EUR}`;
  }, [finalSubtotals?.currentPosSubtotal]);

  const getNegSubtotal = useCallback(() => {
    if (finalSubtotals?.currentNegSubtotal === DEFAULT_SUBTOTAL_SIGN) {
      return finalSubtotals?.currentNegSubtotal;
    }
    return `${finalSubtotals?.currentNegSubtotal || '0.00'} ${CURRENCY.EUR}`;
  }, [finalSubtotals?.currentNegSubtotal]);

  const getTotals = useCallback(() => {
    return getTotalChargesReturns(data || []);
  }, [data]);

  return (
    <View style={styles.container}>
      <View style={{ flex: 1, flexDirection: 'column', paddingLeft: 17 }}>
        <Text style={[pdfStyles.smallTitle]}>{t('CUSTOMERS_REPORT.TOTAL')}</Text>
      </View>
      <Text style={[pdfStyles.smallTitle, pdfStyles.width60]}>
        {getTotals()?.charges} {CURRENCY.EUR}
      </Text>
      <Text style={[pdfStyles.smallTitle, pdfStyles.width60]}>
        {getTotals()?.returns} {CURRENCY.EUR}
      </Text>
      <Text style={[pdfStyles.smallTitle, pdfStyles.width60]}>{getPosSubtotal()}</Text>
      <Text style={[pdfStyles.smallTitle, pdfStyles.width60, { marginRight: 8 }]}>{getNegSubtotal()}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'nowrap',
    paddingTop: 10,
  },
});
